var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Home page")]),_c('p',[_vm._v(" This Todo app is my first app on the vueJS. v.1.0 ")]),_c('router-link',{attrs:{"to":"/todos"}},[_vm._v("Todos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }